import { get, postJson } from "../http/backend";
import { SuccessfulResult } from "./types";

/**
 * 获取共享码
 */
export function getShareCode(
  ewaybillShippingAddressId: number,
  quantity: number,
  consumerName: string,
  unlimitedQuantity?: boolean
) {
  // /ewaybill_account/share/get_code?ewaybillShippingAddressId=6&quantity=1&unlimitedQuantity=true
  return get<{ code: string }>("/ewaybill_account/share/get_code", {
    ewaybillShippingAddressId: ewaybillShippingAddressId,
    quantity: quantity,
    unlimitedQuantity: unlimitedQuantity,
    consumerName: consumerName,
  });
}

/**
 * 使用共享码
 */
export function consumeShareCode(consumeCode: string) {
  return postJson<SuccessfulResult>("/ewaybill_account/share/consume_code", { code: consumeCode });
}
